module.exports = __webpack_public_path__ + "static/media/excellence.aa5b7e2c.jpg";